import { type EditionExtensionsOptions } from './types';
import { createProductExtensions } from './utils';

export { Editions } from './types';
export type { EditionExtensionsOptions } from './types';

export const editionExtensionsWhitelist = ['edition'];

export const createEditionExtensions = createProductExtensions<EditionExtensionsOptions>(
	editionExtensionsWhitelist,
);
